<template>
  <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('温度值(℃)')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.temperatureTop" :placeholder="$t('请输入温度值上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.temperatureBottom" :placeholder="$t('请输入温度值下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('PH值')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.phTop" :placeholder="$t('请输入PH值上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.phBottom" :placeholder="$t('请输入PH值下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('色度')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.chromaTop" :placeholder="$t('请输入色度上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.chromaBottom" :placeholder="$t('请输入色度下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('浑浊度(NTU)')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.ntuTop" :placeholder="$t('请输入浑浊度上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.ntuBottom" :placeholder="$t('请输入浑浊度下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('溶解性总固体(mg/L)')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.dissolvedSolidsTop" :placeholder="$t('请输入溶解性总固体上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.dissolvedSolidsBottom" :placeholder="$t('请输入溶解性总固体下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('硬度(mg/L)')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.hardnessTop" :placeholder="$t('请输入硬度上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.hardnessBottom" :placeholder="$t('请输入硬度下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="ORP(mv)">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.orpTop" :placeholder="$t('请输入ORP上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.orpBottom" :placeholder="$t('请输入ORP下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('氯化物(mg/L)')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.chlorideTop" :placeholder="$t('请输入氯化物上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.chlorideBottom" :placeholder="$t('请输入氯化物下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('余氯(mg/L)')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.residualChlorineTop" :placeholder="$t('请输入余氯上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.residualChlorineBottm" :placeholder="$t('请输入余氯下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('硫酸盐(mg/L)')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.sulfateTop" :placeholder="$t('请输入硫酸盐上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.sulfateBottm" :placeholder="$t('请输入硫酸盐下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('电导率(μS/cm)')">
                <div class="item"><span>{{ $t('上限：') }}</span><a-input v-model="model.electricalConductivityTop" :placeholder="$t('请输入电导率上限')"></a-input></div>
                <div class="item"><span>{{ $t('下限：') }}</span><a-input v-model="model.electricalConductivityBottm" :placeholder="$t('请输入电导率下限')"></a-input></div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  export default {
    name: 'WaterQualityStandardsModal',
    components: {},
    data() {
      let validateRemark = (rule, value, callback) => {
        if(this.model.audit == 0){
          if(value){
            callback();
          }else{
            callback(new Error(this.$t('请输入备注')));
          }
        }else{
          callback();
        }
      };
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        validatorRules: {},
        url: {
          queryByDeviceId: "/jeecg-charge/wq/meterDeviceMetrics/queryByDeviceId",
          add: "/jeecg-charge/wq/meterDeviceMetrics/add",
        },
      }
    },
    watch:{},
    methods: {
      init(row){
        let that = this;
        this.title = this.$t('编辑标准');
        this.visible = true;
        this.model = {
          deviceId: row.meterId
        };
        getAction(this.url.queryByDeviceId,{deviceId: row.meterId}).then(res=>{
          if(res.success){
            this.model = Object.assign({},this.model,res.result||{});
          }
        })
      },
      handleCancel() {
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            postAction(this.url.add,this.model).then((res) => {
              if (res.success) {
                that.$message.success(this.$t('操作成功'));
                that.$emit('ok');
                this.visible = false;
                that.confirmLoading = false;
              } else {
                that.$message.warning(res.message);
              }
            })
          }
        })
      },
    }
  }
</script>
<style scoped lang="less">
  /deep/.ant-form-item-children{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  .item{
    display: flex;
    width: 48%;
    justify-content: space-between;
    span{
      width: 65px;
      line-height: 33px;
    }
  }
</style>